// Import Cookies
import Cookies from 'js-cookie';

const Alert = () => {
  const alert = document.getElementById('tofino-notification');

  if (alert) {
    if (tofinoJS.notificationJS === 'true') {
      // Show the notfication using JS based on the cookie (fixes html caching issue)
      alert.style.display = 'block';
    }
  }
};

export default Alert;
